import lowerFirst from './lower-first';

/**
 * @param {string} prefix
 * @param {string} value
 */
export default function unPrefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/unprefix-prop-name.js
// module id = 715
// module chunks = 0